import expression from "../logic/expression"
import config from "../config"
import tableUtils from "./tableUtils.js"
import logger from "../logger"

const wordRegexWithoutSpecialChars = config.logic.words.wordRegex.withoutSpecialChars
const wordRegexWithSpecialChars = config.logic.words.wordRegex.withSpecialChars

const possibleSumColumnNames = config.logic.words.sumColumns

function preformAnalysis(inputTable, query) {
  if(!inputTable) return null;
  inputTable.rows.pop();
  const columnsCount = inputTable.columnNames.length
  const columnIdsByName = tableUtils.columnIdsByName(inputTable)
  const sumColumnNames = possibleSumColumnNames.filter(columnName => columnIdsByName.has(columnName))
  const sumColumnInputIds = sumColumnNames.map(columnName => columnIdsByName.get(columnName))
  const sumColumnCount = sumColumnNames.length
  if(query.wordsColumns.length == 0) return null;
  for(let col of query.wordsColumns) {
    if(!columnIdsByName.has(col)) return null
  }

  const wordsColumnsInputIds = query.wordsColumns.map(col => columnIdsByName.get(col))

  if(query.categories != 'all') {
    let categories = query.categories
    const categoryColumnsIds = categories.map(col => columnIdsByName.get(col.columnName))

    const prefilteredTable = {
      title: inputTable.title,
      columnNames: inputTable.columnNames.slice(),
      rows: inputTable.rows.filter(row => {
        let match = true
        for(let i = 0; i < categories.length; i++) {
          let value = row[categoryColumnsIds[i]]
          let options = categories[i].options
          match = match && (options.indexOf( value ) != -1)
        }
        return match
      })
    }
    inputTable = prefilteredTable
  }

  let prefilteredData = inputTable.rows
  let summary = new Array(2+sumColumnCount)
  for(let columnId = 0; columnId < sumColumnCount; columnId++) summary[2+columnId] = 0
  for(let row of prefilteredData) {
    for(let columnId = 0; columnId < sumColumnCount; columnId++) {
      let v = +row[sumColumnInputIds[columnId]]
      if(isFinite(v)) summary[2+columnId] += v*100
    }
  }
  summary[0] = 'Summary'
  summary[1] = ''

  let phraseMap = new Map()
  const dataRowsCount = inputTable.rows.length
  for(let rowId = 0; rowId < dataRowsCount; rowId++) {
    let row = inputTable.rows[rowId]
    //console.log("ROW", row, wordsColumnInputId)

    const phrases = []

    for(let wordsColId of wordsColumnsInputIds) {
      const wordsText = query.ignoreCase ? (""+row[wordsColId]).toLowerCase() : row[wordsColId]
      const words = query.ignoreSpecialCharacters
        ? wordsText.match(wordRegexWithoutSpecialChars) || []
        : wordsText.match(wordRegexWithSpecialChars) || []
      const wordCount = words.length
      for(let phraseLength = +query.minWords; phraseLength <= +query.maxWords; phraseLength++) {
        for (let firstWordId = 0; firstWordId <= (wordCount - phraseLength); firstWordId++) {
          const phraseWords = words.slice(firstWordId, firstWordId + phraseLength)
          //console.log("PW", firstWordId, firstWordId + phraseLength, phraseLength, phraseWords)
          const phraseText = phraseWords.join(' ')
          if(phrases.indexOf(phraseText) == -1) phrases.push(phraseText)
        }
      }
    }

    for(let phrase of phrases) {
      let accumulator = phraseMap.get(phrase)
      if(!accumulator) {
        accumulator = {
          phraseText: phrase,
          overallCount: 0,
          sumColumns: new Array(sumColumnCount)
        }
        for(let i = 0; i < sumColumnCount; i++) {
          accumulator.sumColumns[i] = 0.0
        }
      }
      for(let i = 0; i < sumColumnCount; i++) {
        accumulator.sumColumns[i] += (row[sumColumnInputIds[i]] * 100)
      }
      accumulator.overallCount += 100;
      phraseMap.set(phrase, accumulator)
    }
  }

  let phrases = new Array(phraseMap.size)
  let phraseId = 0
  for (var [phrase, accumulator] of phraseMap.entries()) {
    phrases[phraseId++] = accumulator
  }

  if(typeof window != 'undefined') window.out = phrases
  return {
    title: "Analiza słów z "+inputTable.title,
    columnNames: ['Phrase', 'Count'].concat(sumColumnNames),
    rows: phrases.map(phrase => [phrase.phraseText, phrase.overallCount].concat(phrase.sumColumns)),
    summary: summary
  }
}

function calculateTable(outputTable) {
  if (!outputTable) return null
  let columnNames = outputTable.columnNames
  let columnsCount = columnNames.length
  const columnIdsByName = tableUtils.columnIdsByName(outputTable)

  const outputData = outputTable.rows
  let summary = outputTable.summary

  /// CALCULATION:
  const clicksColumnId = columnIdsByName.get("Clicks")
  const impressionsColumnId = columnIdsByName.get("Impressions")
  const costColumnId = columnIdsByName.get("Cost")
  const conversionsColumnId = columnIdsByName.get("Conversions")
  const conversionsValueColumnId = columnIdsByName.get("ConversionValue")

  let calculatedData = outputData

  if(clicksColumnId !== undefined && impressionsColumnId !== undefined) { /// CTR
    for(let row of calculatedData) {
      row.push(row[clicksColumnId] * 100 * 100 / row[impressionsColumnId])
    }
    summary.push(summary[clicksColumnId] * 100 * 100 / summary[impressionsColumnId])
    columnNames.push('CTR')
  }

  if(conversionsValueColumnId !== undefined && costColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[conversionsValueColumnId] * 100 / row[costColumnId])
    }
    summary.push(summary[conversionsValueColumnId] * 100 / summary[costColumnId])
    columnNames.push('ROAS')
  }

  if(costColumnId !== undefined && conversionsColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[costColumnId] * 100 / row[conversionsColumnId])
    }
    summary.push(summary[costColumnId] * 100 / summary[conversionsColumnId])
    columnNames.push('CC')
  }

  if(conversionsColumnId !== undefined && clicksColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[conversionsColumnId] * 100 * 100 / row[clicksColumnId])
    }
    summary.push(summary[conversionsColumnId] * 100 * 100 / summary[clicksColumnId])
    columnNames.push('CR')
  }

  for (let columnId = columnsCount; columnId < columnNames.length; columnId++) {
    const columnName = columnNames[columnId]
    columnIdsByName.set(columnName, columnId)
  }
  columnsCount = columnNames.length

  const calculatedTable = {
    title: outputTable.title,
    columnNames: columnNames,
    rows: calculatedData,
    summary: summary
  }
  return calculatedTable
}

function prepareTableView(calculatedTable, viewSettings) {
  if (!calculatedTable) return null
  console.log("PREP VIEW!")
  const calculatedData = calculatedTable.rows

  let columnNames = calculatedTable.columnNames
  let columnsCount = columnNames.length
  let summary = calculatedTable.summary

  /*/// REMOVING EMPTY COLUMNS
  var emptyColumns = []
  for(let colId = 0; colId < columnsCount; colId++) {
    let empty = true;
    for(let row of calculatedData) {
      empty = empty && (Number.isNaN(row[colId]) || row[colId]=='' || row[colId]==Infinity || row[colId]== -Infinity)
    }
    if(empty) emptyColumns.push(colId - emptyColumns.length)
  }
  for(let emptyId of emptyColumns) {
    columnNames.splice(emptyId, 1)
    summary.splice(emptyId, 1)
    for(let row of calculatedData) {
      row.splice(emptyId, 1)
    }
  }*/

  calculatedTable.columnNames = columnNames
  const columnIdsByName = tableUtils.columnIdsByName(calculatedTable)

  /// FILTERING:
  let filteredData = calculatedData
  if(viewSettings.enableFilter && viewSettings.filter) {
    const filterFunc = expression.compileFilter(viewSettings.filter, columnIdsByName)
    // console.log("COMPILED FILTER", filterFunc)
    filteredData = calculatedData.filter(filterFunc)
  }

  /// SEARCH FILTERING:
  if(viewSettings.searchText != '') filteredData = filteredData.filter(row => {
    let found = false
    for(let cell of row) {
      if(cell.indexOf && cell.toLowerCase().indexOf(viewSettings.searchText.toLowerCase()) != -1) found = true
    }
    return found
  })

  /// SORTING:
  let sortedData = filteredData
  if (filteredData.length > 0) {
    sortedData = filteredData.slice()
    const sortColumnId = columnIdsByName.get(viewSettings.sortBy)
    //console.log("SORT TABLE", sortedData, "BY", viewSettings.sortBy, sortColumnId)
    if(typeof sortedData[0][sortColumnId] == 'number') {
      if (viewSettings.sortAsc) {
        sortedData.sort((a, b) => a[sortColumnId] - b[sortColumnId])
      } else {
        sortedData.sort((a, b) => b[sortColumnId] - a[sortColumnId])
      }
    } else {
      if (viewSettings.sortAsc) {
        sortedData.sort(
          (a, b) => a[sortColumnId] > b[sortColumnId] ? 1 : (a[sortColumnId] < b[sortColumnId] ? -1 : 0)
        )
      } else {
        sortedData.sort(
          (a, b) => b[sortColumnId] > a[sortColumnId] ? 1 : (b[sortColumnId] < a[sortColumnId] ? -1 : 0)
        )
      }
    }
  }

  /// OUTPUT:
  const sortedTable = {
    title: calculatedTable.title,
    columnNames: columnNames,
    columnTypes: ["text"].concat(columnNames.slice(1).map(t=>"number")),
    rows: sortedData,
    summary: summary
  }
  return sortedTable
}

function generateTips(inputTable, outputTable, maxTips) {
  const tipsRules = config.wordsTips
  let tips = []
  for(let rule of tipsRules) {
    let tip = rule(inputTable, outputTable)
    if(tip) tips.push(tip)
    if(tips.length >= maxTips) return tips
  }
  return tips
}

function findCategories(inputTable) {
  let categories = []
  let rowCount = inputTable.rows
  for(let columnId = 0; columnId < inputTable.columnNames.length; columnId++) {
    let columnName = inputTable.columnNames[columnId]
    if(config.logic.categoryColumns.indexOf(columnName) == -1) continue;
    let categoriesMap = new Map()
    let categoriesCount = 0
    for(let row of inputTable.rows) {
      if(!categoriesMap.has(row[columnId])) {
        categoriesMap.set(row[columnId], true)
        categoriesCount++
      }
    }
    categories.push({
      columnName,
      options: Array.from(categoriesMap.keys())
    })
  }
  return categories
}

const methods = {
  preformAnalysis,
  calculateTable,
  prepareTableView,
  generateTips,
  findCategories
}

export default methods;

if(typeof window == "undefined" || window.document === undefined) { // Web Worker Code
  logger.install()
  logger.addWorkerParentLogDestination()
  onmessage = (msg) => {
    let { method, serializedArgs, requestId } = msg.data
    let args = serializedArgs
    //console.log("WORKER CALL", method, args)
    let result = methods[method].apply(null, args)
    //console.log("WORKER RES", result)
    postMessage({
      type: "response",
      result,
      requestId
    })
  }
  postMessage({
    type: "ready"
  })
}



// WEBPACK FOOTER //
// ./src/logic/wordsAnalyzer.js